interface Props {
  className?: string;
}

export default function DialogBoxIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 0.2C14 0.0895429 13.9105 0 13.8 0H0.2C0.0895426 0 0 0.089543 0 0.2V9.8C0 9.91046 0.0895431 10 0.2 10H3V13L6.707 10H13.8C13.9105 10 14 9.91046 14 9.8V0.2ZM13 8.8C13 8.91046 12.9105 9 12.8 9H6.5H6L4 11V9H3.5H1.2C1.08954 9 1 8.91046 1 8.8V1.2C1 1.08954 1.08954 1 1.2 1H12.8C12.9105 1 13 1.08954 13 1.2V8.8Z"
        fill="currentColor"
      />
      <line
        x1="2"
        y1="3.44995"
        x2="12"
        y2="3.44995"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M2 6.25H9" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
